import React__default, { useMemo, useState, useEffect } from 'react';
import { I as IntlProvider } from './3rdPartyModules/react-intl/lib/src/components/provider-DxrpHEUT.js';

/* eslint-disable react-hooks/exhaustive-deps */
function InternalIntlProvider({
  translations,
  children
}) {
  const {
    locale
  } = translations;
  const InitalTranslationComponent = useMemo(() => translations.component, []);
  const [translationMap, setTranslationsMap] = useState(undefined);
  useEffect(() => {
    if (translations.translationImports && translations.translationImports[locale]) {
      translations.translationImports[locale]().then(res => {
        setTranslationsMap(res.default.translations);
      });
    } else if ('translations' in translations.component) {
      setTranslationsMap(translations.component.translations);
    }
  }, [locale]);
  return /*#__PURE__*/React__default.createElement(InitalTranslationComponent, null, initalTranslationsMap => /*#__PURE__*/React__default.createElement(IntlProvider, {
    key: locale,
    locale: locale,
    defaultLocale: "en-US",
    messages: translationMap !== null && translationMap !== void 0 ? translationMap : initalTranslationsMap
  }, children));
}

export { InternalIntlProvider as I };
//# sourceMappingURL=Provider-DZ_dmGP_.js.map
